import { MapPin, Navigation } from 'lucide-react';
import { fb, sinkTxt, navUrl } from '../lib/floodBal';
import { flyTo } from '../lib/vis';
import { netOk } from '../lib/netGuard';

// the five deepest flooded hollows: tap = show on the map, arrow = route there with Google Maps
export function SinkList({ sinks }) {
  const T = fb();
  return (
    <div className="fl-sinks" data-testid="flood-sinks">
      <b>{T.skT}</b>
      {!sinks.length ? <small className="muted" data-testid="flood-sinks-none">{T.skNone}</small> : sinks.map((h) => (
        <div key={h.no} className="fl-sink" data-testid={`flood-sink-${h.no}`}>
          <button type="button" className="fl-sink-main" data-testid={`flood-sink-show-${h.no}`} onClick={() => flyTo([[h.lat, h.lon]])}>
            <span className="fl-sink-no">{h.no}</span><span><b>{sinkTxt(h, T)}</b><small>{h.near ? T.skNear.replace('{n}', h.near.name).replace('{m}', Math.round(h.near.dm)) : `${h.lat.toFixed(5)}, ${h.lon.toFixed(5)}`}</small></span><MapPin size={14} />
          </button>
          {netOk(navUrl(h)) && <a className="chip" data-testid={`flood-sink-nav-${h.no}`} href={navUrl(h)} target="_blank" rel="noreferrer" aria-label={T.skNav}><Navigation size={14} /></a>}
        </div>
      ))}
      <small className="muted">{T.skHint}</small>
    </div>
  );
}
